import * as v from 'valibot';

import { hubReportStatusSchema } from '#entities';

export const hubsResourceReportResponseSchema = v.object({
  /** Array of hub resource reports */
  data: v.array(hubReportStatusSchema),
  /** Timestamp when the report was generated (ISO 8601) */
  generatedAt: v.string(),
  dataGeneratedAt: v.string(),
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
});

export type HubsResourceReportResponse = v.InferInput<
  typeof hubsResourceReportResponseSchema
>;
